module.exports = __webpack_public_path__ + "arrow_right.d9ccc77c8240ad0dc272.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/arrow_right.svg
// module id = 211
// module chunks = 2